module.exports = __webpack_public_path__ + "assets/40a32579490dcbf67b869fd793e7af99.svg";